import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.scss'],
})
export class CurrencyInputComponent implements OnChanges {
  @Input() currency: string = 'SAR';
  @Input() min!: number;
  @Input() max!: number;
  @Input() readOnly = false;
  @Input() set Amount(val: number) {
    if (val != 0)
      this.value = val;
  }

  @Output() AmountChange = new EventEmitter<any>();

  value: number = 0;

  rand = Math.random();
  maxExceeded = false;
  minExceeded = false;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['Amount'] && this.value != undefined){
      this.format(this.value?.toString());
    }
  }

  format(val: string) {
    val = val.replace(/\D/g, '') || '0';
    val = val.slice(0, this.max.toString().length);
    let num = parseInt(val);
    if (isNaN(num)) return;
    if (num > this.max) {
      this.maxExceeded = true;
    } else this.maxExceeded = false;
    if (num < this.min) {
      this.minExceeded = true;
    } 
    else 
      this.minExceeded = false;
    this.value = num;
    this.emitcurrentValue();
  }

  // addComma(val: string | number): string {
  //   if (!val) return '';
  //   val = val.toString();
  //   val = [...val].reverse().join('');
  //   let fragments = val
  //     .match(/(.{1,3})/g)
  //     ?.map((el) => [...el].reverse().join(''));
  //   fragments?.reverse();
  //   return fragments?.join(',') || '';
  // }
  emitcurrentValue() {
    if (this.maxExceeded || this.minExceeded)
      this.AmountChange.emit(0);
    else 
      this.AmountChange.emit(this.value);
  }
}
